// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';
import {
  smLoading,
  mdLoading,
  lgLoading,
} from '@tcp/core/src/components/features/browse/CategoryListingPage/styles/PaginatedPage.style';

export const HrCarouselDesktop = Styled.div`
  margin-bottom: 18px;
  .carousel-wrapper {
    background-color: ${(props) => props.theme.colors.PRIMARY.COLOR1};
    box-sizing: border-box;
    @media ${(props) => props.theme.mediaQuery.small} {
      padding: 8px 8px 8px 8px;
      margin: 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: 12px 40px 12px 25px;
      margin: 0 20px 13px 20px;
    }
  }
  .tile-wrapper {
    height: auto;
    position: relative;
  }

  .tile-wrapper.espot-container {
    display: flex;
    align-items: center;
  }

  .espot-category-name-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    display: flex;
    box-sizing: border-box;
    height: 100%;
    padding: 38px 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #005d95;
    overflow: hidden;

    .espot-category-name {
      writing-mode: vertical-rl;
      text-orientation: upright;
      text-transform: uppercase;
      color: #fff;
      text-align: center;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 900;
      line-height: 150%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media ${(props) => props.theme.mediaQuery.medium} {
        font-size: 16px;
      }
    }
  }
`;

export const CategoryBar = Styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 20px 0px 20px;
  h3 {
    font-weight: 700;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    @media ${(props) => props.theme.mediaQuery.small} {
      font-size: 18px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 26px;
    }
  }
  .item-count {
    margin-left: 8px;
    @media screen and (max-width: 400px) {
      flex: 1;
      font-size: 13px;
    }
  }
  .cat-info {
    display: flex;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: inline-flex;
    }
  }
  .cat-link a {
    font-weight: bold;
    text-decoration: underline;
    white-space: nowrap;
    color: #005d95;
    @media ${(props) => props.theme.mediaQuery.small} {
      font-size: 14px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: 16px;
    }
  }
`;

export const SeoHeaderData = Styled.div`
  padding: 0px 20px;
`;

export const SeoText = Styled.div`
  font-size: 14px;
  line-height: 19px;
  font-family: 'Nunito';
  font-weight: 400;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    font-size: 12px;
    line-height: 14px;
  }
`;

export const ContainerDiv = Styled.div`
  padding-bottom: 8px;
`;

export const StyledESpotPromoSkeleton = Styled.div`
  height: 100%;
  background-clip: content-box;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.6),
        rgba(255, 255, 255, 0)
      ),
      // animation
      linear-gradient(#d8d8d8 100%, transparent 0),
      linear-gradient(white, transparent 0);
    background-size: 100%;
    animation: ${smLoading} 0.5s ease-in-out infinite;
  }

  @media ${(props) => props.theme.mediaQuery.medium} {
    &::after {
      animation: ${mdLoading} 0.5s ease-in-out infinite;
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    &::after {
      animation: ${lgLoading} 0.5s ease-in-out infinite;
    }
  }
`;
